/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceEventOut } from './sequenceEventOut';

export interface SequenceEventsPollResponse {
  events: SequenceEventOut[];
  server_time: string;
}
